import { Component, OnInit, ChangeDetectionStrategy, Input, ChangeDetectorRef } from '@angular/core';
import { PurchaseService } from '@schoolbelle/api/purchase';
import { FormControl, FormArray, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { sum, get } from 'lodash-es';

@Component({
  selector: 'app-cost-details',
  templateUrl: './cost-details.component.html',
  styleUrls: ['./cost-details.component.css'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class CostDetailsComponent implements OnInit {

  @Input('form') form:FormGroup;
  products:FormArray;
  paymentCurrency:FormControl;
  taxRate:FormControl;
  
  protected subscriptions = new Subscription();
  constructor(
    protected purchase:PurchaseService,
    protected cdRef:ChangeDetectorRef,
  ) { 
  }

  ngOnInit(): void {
    this.products = this.form.get('products') as FormArray;
    this.paymentCurrency = this.form.get('paymentCurrency') as FormControl;
    this.taxRate = this.form.get('taxRate') as FormControl;
    this.subscriptions.add(
      this.products.valueChanges.subscribe((v)=>{
        this.cdRef.detectChanges();
      })
    );  
  }
  ngOnDestroy () {
    this.subscriptions.unsubscribe();
  }

  get monthly_price_amount ():number {
    return sum(this.products.controls.map(productFormGroup=>{
      const product_id = get(productFormGroup.value, ['productId']);
      const quantity = get(productFormGroup.value, ['quantity']);
      if (!product_id) return 0;
      const product_info = this.purchase.currentProducts.find(p=>p.product_id === product_id);
      if (!product_info) return 0;
      const {price_amount, expires } = product_info;
      if (!expires) return 0;
      const price_amount_with_currency = (get(price_amount, [this.paymentCurrency.value]) || 0);
      return price_amount_with_currency * quantity;
    })) * (1 + this.taxRate.value);
  }
  get none_monthly_price_amount ():number {
    return sum(this.products.controls.map(productFormGroup=>{
      const product_id = get(productFormGroup.value, ['productId']);
      const amount = get(productFormGroup.value, ['amount']);
      const quantity = get(productFormGroup.value, ['quantity']);
      if (!product_id) return 0;
      const product_info = this.purchase.currentProducts.find(p=>p.product_id === product_id);
      if (!product_info) return 0;
      const {price_amount, expires } = product_info;
      if (expires) return 0;
      const price_amount_with_currency = (get(price_amount, [this.paymentCurrency.value]) || 0);
      return price_amount_with_currency * amount * quantity;
    })) * (1 + this.taxRate.value);
  }  
  get price_amount ():number {
    return sum(this.products.controls.map(productFormGroup=>{
      const product_id = get(productFormGroup.value, ['productId']);
      const amount = get(productFormGroup.value, ['amount']);
      const quantity = get(productFormGroup.value, ['quantity']);
      if (!product_id) return 0;
      const product_info = this.purchase.currentProducts.find(p=>p.product_id === product_id);
      if (!product_info) return 0;
      const {price_amount} = product_info;
      const price_amount_with_currency = (get(price_amount, [this.paymentCurrency.value]) || 0);
      return price_amount_with_currency * amount * quantity;
    })) * (1 + this.taxRate.value);
  }
  get months ():number {
    const monthly_product_ctrl = this.products.controls.find(productFormGroup=>{
      const product_id = get(productFormGroup.value, ['productId']);

      const product_info = this.purchase.currentProducts.find(p=>p.product_id === product_id);
      if (!product_info) return false;
      const { expires } = product_info;
      if (!expires) return false;

      return true;
    });
    if (!monthly_product_ctrl) return 0;
    return monthly_product_ctrl.get('amount').value;
  }
}
